<script lang="ts" setup>
import { SingleSelectList, SingleSelectListItem } from '@laam/ui/base';

interface SizeTableProps {
	sizeChart: {
		heading: Record<string, string[]>;
		data: Record<string, number[]>;
	};
	title: string;
	nodeValue?: string;
}

const props = defineProps<SizeTableProps>();

const units = ref('in');
// let cmToInch = 0.3937;
const inchToCm = 2.54;

function returnUnit(valInInches: number) {
	if (String(valInInches).includes('-') && units.value === 'cm') {
		const values = String(valInInches)
			.split('-')
			.map((val) => parseInt(val) * inchToCm);
		return `${values[0]}-${values[1]}`;
	}
	if (units.value === 'cm') {
		return (valInInches * inchToCm).toFixed(1);
	} else {
		return valInInches;
	}
}

const headingTitle = computed(() => {
	if (props.sizeChart != null || typeof props.sizeChart !== undefined) {
		return Object.keys(props.sizeChart['heading'])[0];
	} else {
		return '';
	}
});
const headingData = computed(() => {
	if (props.sizeChart != null || typeof props.sizeChart !== undefined) {
		return props.sizeChart['heading'][
			Object.keys(props.sizeChart['heading'])[0] || ''
		];
	} else {
		console.log('Size Table  headingData undefined or null');
		return [];
	}
});
const rowData = computed(() => {
	if (props.sizeChart != null || typeof props.sizeChart !== undefined) {
		return props.sizeChart['data'];
	} else {
		console.log('Size Table rowData undefined or null');
		return {};
	}
});
const hasSizeChartData = computed(() => {
	return (
		headingData.value &&
		headingData.value.length > 0 &&
		Object.keys(rowData.value).length > 0
	);
});
</script>

<template>
	<div v-if="hasSizeChartData">
		<div class="pb-3xl pt-8xl px-3xl flex items-center justify-between">
			<span class="text-xl font-medium text-gray-800 capitalize">{{
				title
			}}</span>

			<div
				v-if="props?.nodeValue?.toLowerCase() !== 'footwear'"
				class="gap-xs flex items-start bg-gray-100 rounded"
			>
				<SingleSelectList
					v-model="units"
					class="gap-md grid grid-cols-2"
					default-value="in"
				>
					<SingleSelectListItem
						value="cm"
						class="props.sizeChart-[state=checked]:bg-gray-800 props.sizeChart-[state=checked]:text-white p-md"
					>
						Cm
					</SingleSelectListItem>
					<SingleSelectListItem
						value="in"
						class="props.sizeChart-[state=checked]:bg-gray-800 props.sizeChart-[state=checked]:text-white p-md"
					>
						In
					</SingleSelectListItem>
				</SingleSelectList>
			</div>
		</div>

		<div class="no-scrollbar inline-block max-w-full min-w-full overflow-auto">
			<table class="min-w-full text-center">
				<thead class="h-9xl">
					<tr class="border border-gray-300">
						<th
							scope="col"
							class="px-5xl text-start text-xs font-medium text-gray-600 capitalize"
						>
							{{ headingTitle }}
						</th>

						<th
							v-for="(item, index) in headingData"
							:key="index"
							scope="col"
							class="px-md text-xs font-medium text-gray-600 capitalize"
						>
							<div>
								{{ item }}
								({{ units }})
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(value, key, index) in rowData"
						:key="index"
						class="bg-white border-b border-gray-300"
					>
						<td class="cellt1">
							{{ key }}
						</td>
						<td v-for="(item, index2) in value" :key="index2" class="cellt2">
							{{ returnUnit(item) }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
	display: none;
}

.cellt1 {
	@apply whitespace-nowrap px-5xl py-md text-left text-sm font-medium  text-gray-800;
}
.cellt2 {
	@apply whitespace-nowrap px-7xl py-md text-sm  text-gray-600;
}
</style>
